module.exports = __webpack_public_path__ + "img/img-ab288f7a.e7d2dbfb.png";